module.exports = __webpack_public_path__ + "media/report_center/no-image-30f7a145.png";